webpackJsonp([51],{

/***/ 178:
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "app",
  watch: {
    $route: function $route() {
      var _this = this;

      this.$uweb.ready().then(function () {
        var location = window.location;
        var content_url = location.pathname + location.hash;
        var referer_url = "/";
        _this.$uweb.trackPageview(content_url, referer_url);
      }).catch(function () {});
    }
  }
};

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(210);
module.exports = __webpack_require__(412);


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

var _stringify = __webpack_require__(127);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(198);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(125);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(432);

var _App2 = _interopRequireDefault(_App);

var _vueRouter = __webpack_require__(434);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueUweb = __webpack_require__(435);

var _vueUweb2 = _interopRequireDefault(_vueUweb);

__webpack_require__(436);

var _share = __webpack_require__(444);

var _share2 = _interopRequireDefault(_share);

var _appRouter = __webpack_require__(446);

var _appRouter2 = _interopRequireDefault(_appRouter);

var _axios = __webpack_require__(454);

var _axios2 = _interopRequireDefault(_axios);

var _Client = __webpack_require__(473);

var _Client2 = _interopRequireDefault(_Client);

var _vueCookie = __webpack_require__(207);

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _qs = __webpack_require__(476);

var _qs2 = _interopRequireDefault(_qs);

__webpack_require__(191);

var _mintUi = __webpack_require__(189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueUweb2.default, '1272883543');


window.setShareInfo = _share2.default;

var FastClick = __webpack_require__(479);
FastClick.attach(document.body);

_axios2.default.defaults.baseURL = '/api';
_vue2.default.prototype.$http = _axios2.default;

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueCookie2.default);

_vue2.default.prototype.$client = new _Client2.default();


var router = new _vueRouter2.default({
  mode: "history",

  base: '/',
  linkActiveClass: 'active',
  routes: _appRouter2.default
});

_axios2.default.interceptors.request.use(function (request) {
  if (request.data && request.method === 'post') {
    request.data = _qs2.default.stringify(request.data.params);
  }
  return request;
});

_axios2.default.interceptors.response.use(function (response) {
  if (response.data.status == 'success') {
    console.log('axios success');
    return response.data.data;
  } else {
    console.log('axios fail');
    console.log(response.data);
    (0, _mintUi.Toast)({
      message: response.data.data.error,
      position: 'bottom',
      duration: 2000
    });

    if ([10118].includes(response.data.data.error_code)) {
      return response.data.data.error_code;
    }
    return false;
  }
}, function (error) {
  console.log('axios error');
  (0, _mintUi.Toast)({
    message: '请求异常,请检查网络',
    position: 'bottom',
    duration: 2000
  });
  return _promise2.default.reject(error);
});

router.beforeEach(function (to, from, next) {
  var token = _vueCookie2.default.get('FOUNQ_TOKEN');
  if (token) {
    _axios2.default.get('user/info', {
      params: {
        token: token
      }
    }).then(function (response) {
      if (response) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userinfo', (0, _stringify2.default)(response));
      }
      document.title = to.meta.title;
      next();
    }).catch(function (error) {
      document.title = to.meta.title;
      next();
    });
  } else {
    sessionStorage.clear();
    document.title = to.meta.title;
    next();
  }
});

new _vue2.default({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c7bf4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(433);
var normalizeComponent = __webpack_require__(188)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c7bf4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _stringify = __webpack_require__(127);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(190);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (window, factory) {
  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
    module.exports = factory();
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    window.eventUtil = factory();
  }
})(undefined, function () {
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var JSBridge = window.JSBridge || (window.JSBridge = {});

  var CUSTOM_PROTOCOL_SCHEME = 'FQ-SMGFSQ-JSBridge';

  var API_Name = 'app_bridge';

  var messagingIframe = document.createElement('iframe');
  messagingIframe.style.display = 'none';
  messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://' + API_Name;

  document.documentElement.appendChild(messagingIframe);

  var responseCallbacks = {};

  var uniqueId = 1;

  var messageHandlers = {};

  var dispatchMessagesWithTimeoutSafety = true;

  var sendMessageQueue = [];

  var Inner = {
    registerHandler: function registerHandler(handlerName, handler) {
      console.log('register-h5 ' + handlerName);
      messageHandlers[handlerName] = handler;
    },

    callHandler: function callHandler(handlerName, data, callback) {
      console.log('call-native ' + handlerName);

      if (arguments.length == 3 && typeof data == 'function') {
        callback = data;
        data = null;
      }
      _doSend({
        handlerName: handlerName,
        data: data
      }, callback);
    },

    _fetchQueue: function _fetchQueue() {
      var messageQueueString = (0, _stringify2.default)(sendMessageQueue);
      sendMessageQueue = [];
      return messageQueueString;
    },

    _handleMessageFromNative: function _handleMessageFromNative(messageJSON) {
      setTimeout(_doDispatchMessageFromNative);

      function _doDispatchMessageFromNative() {
        var message;
        try {
          message = JSON.parse(messageJSON);
        } catch (e) {
          console.error("原生调用H5方法出错,传入参数错误");
          return;
        }

        var responseCallback;
        if (message.responseId) {
          responseCallback = responseCallbacks[message.responseId];
          if (!responseCallback) {
            return;
          }

          responseCallback(message.responseData);
          delete responseCallbacks[message.responseId];
        } else {
          if (message.callbackId) {
            var callbackResponseId = message.callbackId;
            responseCallback = function responseCallback(responseData) {
              _doSend({
                handlerName: message.handlerName,
                responseId: callbackResponseId,
                responseData: responseData
              });
            };
          }

          var handler = messageHandlers[message.handlerName];
          if (!handler) {
            console.log('你tm没注册! 调用个鸡巴!');
          } else {
            handler(message.data, responseCallback);
          }
        }
      }
    }

  };

  function _doSend(message, responseCallback) {
    if (responseCallback) {
      var callbackId = Util.getCallbackId();

      responseCallbacks[callbackId] = responseCallback;

      message['callbackId'] = callbackId;
    }
    var uri;

    var ua = navigator.userAgent;
    if (ua.match(/(iPhone\sOS)\s([\d_]+)/) || ua.match(/(iPad).*OS\s([\d_]+)/)) {
      sendMessageQueue.push(message);
      uri = Util.getUri();
    } else {
      uri = Util.getUri(message);
    }

    messagingIframe.src = uri;
  }

  var Util = {
    getCallbackId: function getCallbackId() {
      return 'cb_' + uniqueId++ + '_' + new Date().getTime();
    },

    getUri: function getUri(message) {
      var uri = CUSTOM_PROTOCOL_SCHEME + '://' + API_Name;
      if (message) {
        var callbackId, method, params;
        if (message.callbackId) {
          callbackId = message.callbackId;
          method = message.handlerName;
          params = message.data;
        } else if (message.responseId) {
          callbackId = message.responseId;
          method = message.handlerName;
          params = message.responseData;
        }

        params = this.getParam(params);

        uri += ':' + callbackId + '/' + method + '?' + params;
      }

      return uri;
    },
    getParam: function getParam(obj) {
      if (obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object') {
        return (0, _stringify2.default)(obj);
      } else {
        return obj || '';
      }
    }
  };
  for (var key in Inner) {
    if (!hasOwnProperty.call(JSBridge, key)) {
      JSBridge[key] = Inner[key];
    }
  }

  window.smgfsq = {};

  smgfsq = {
    initShareConfig: function initShareConfig(shareInfo) {
      console.log('call jsbridge');
      var config = arguments[2] ? arguments[2] : {};
      var callback = arguments[1] ? arguments[1] : {};

      JSBridge.callHandler('initShareConfig', {
        'shareInfo': {
          'title': shareInfo.title && shareInfo.title != '' ? shareInfo.title : '',
          'desc': shareInfo.desc && shareInfo.desc != '' ? shareInfo.desc : '',
          'link': shareInfo.link && shareInfo.link != '' ? shareInfo.link : '',
          'imgUrl': shareInfo.imgUrl && shareInfo.imgUrl != '' ? shareInfo.imgUrl : ''
        },
        'config': {
          'menu': typeof config.menu != 'undefined' && config.menu !== '' ? config.menu : 1,
          'sina': typeof config.sina != 'undefined' && config.sina !== '' ? config.sina : 1,
          'qq': typeof config.qq != 'undefined' && config.qq !== '' ? config.qq : 1,
          'qZone': typeof config.qZone != 'undefined' && config.qZone !== '' ? config.qZone : 1,
          'weChat': typeof config.weChat != 'undefined' && config.weChat !== '' ? config.weChat : 1,
          'weMoments': typeof config.weMoments != 'undefined' && config.weMoments !== '' ? config.weMoments : 1,
          'refresh': typeof config.refresh != 'undefined' && config.refresh !== '' ? config.refresh : 1,
          'copy': typeof config.copy != 'undefined' && config.copy !== '' ? config.copy : 1,
          'browser': typeof config.browser != 'undefined' && config.browser !== '' ? config.browser : 1 }
      }, function (res) {
        callback && callback(res);
      });
    },

    H2N_initShareConfig: function H2N_initShareConfig(config) {
      var shareInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      JSBridge.callHandler('initShareConfig', {
        'config': {
          'menu': typeof config.menu != 'undefined' && config.menu !== '' ? config.menu : 0,
          'sina': typeof config.sina != 'undefined' && config.sina !== '' ? config.sina : 0,
          'qq': typeof config.qq != 'undefined' && config.qq !== '' ? config.qq : 0,
          'qZone': typeof config.qZone != 'undefined' && config.qZone !== '' ? config.qZone : 0,
          'weChat': typeof config.weChat != 'undefined' && config.weChat !== '' ? config.weChat : 0,
          'weMoments': typeof config.weMoments != 'undefined' && config.weMoments !== '' ? config.weMoments : 0,
          'refresh': typeof config.refresh != 'undefined' && config.refresh !== '' ? config.refresh : 0,
          'copy': typeof config.copy != 'undefined' && config.copy !== '' ? config.copy : 0,
          'browser': typeof config.browser != 'undefined' && config.browser !== '' ? config.browser : 0 },
        'shareInfo': {
          'title': shareInfo.title && shareInfo.title != '' ? shareInfo.title : '',
          'desc': shareInfo.desc && shareInfo.desc != '' ? shareInfo.desc : '',
          'link': shareInfo.link && shareInfo.link != '' ? shareInfo.link : '',
          'imgUrl': shareInfo.imgUrl && shareInfo.imgUrl != '' ? shareInfo.imgUrl : ''
        }
      }, function (res) {
        callback && callback(res);
      });
    },
    H2N_login: function H2N_login() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      JSBridge.callHandler('login', {
        'callback': callback
      }, function (res) {
        callback && callback(res);
      });
    },
    N2H_hasShare: function N2H_hasShare(callbackFunc) {
      JSBridge.registerHandler('hasShare', function (data, callback) {
        console.log('answer-native HasShare');
        console.log('测试函数接收到数据:' + (0, _stringify2.default)(data));
        callbackFunc && callbackFunc();
      });
    }
  };
});

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

var require;var require;var __WEBPACK_AMD_DEFINE_RESULT__;var require;(function () {
  var wxapi = "//res.wx.qq.com/open/js/jweixin-1.0.0.js",
      qqapi = "//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152",
      qzapi = "//qzonestyle.gtimg.cn/qzone/phone/m/v4/widget/mobile/jsbridge.js?_bid=339",
      smapi = "//h5.sns.founq.com/static/sdk/js/sdk.js?_t=1";
  var require;
  function _require(url, onload) {
    var doc = document;
    var head = doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
    var node = doc.createElement("script");
    node.onload = onload;
    node.onerror = function () {};
    node.async = true;
    node.src = url[0];
    head.appendChild(node);
  }
  function _initWX(data) {
    if (!data.WXconfig) {
      return;
    }
    require([wxapi], function (wx) {
      if (!wx.config) {
        wx = window.wx;
      }
      var conf = data.WXconfig;
      wx.config({ debug: false, appId: conf.appId, timestamp: conf.timestamp, nonceStr: conf.nonceStr, signature: conf.signature, jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareQZone"] });
      wx.error(function (res) {});
      wx.ready(function () {
        var config = { title: data.title, desc: data.summary, link: data.url, imgUrl: data.pic, type: "", dataUrl: "", success: function success() {
            data.callback && data.callback();
          }, cancel: function cancel() {} };
        wx.onMenuShareAppMessage(config);
        wx.onMenuShareQQ(config);
        wx.onMenuShareQZone(config);
        if (conf.swapTitleInWX) {
          wx.onMenuShareTimeline({ title: data.summary, desc: data.title, link: data.url, imgUrl: data.pic, type: "", dataUrl: "", success: function success() {
              data.callback && data.callback();
            }, cancel: function cancel() {} });
        } else {
          wx.onMenuShareTimeline(config);
        }
      });
    });
  }
  function _initQQ(data) {
    var info = { title: data.title, desc: data.summary, share_url: data.url, image_url: data.pic };
    function doQQShare() {
      try {
        if (data.callback) {
          window.mqq.ui.setOnShareHandler(function (type) {
            if (type == 3 && (data.swapTitle || data.WXconfig && data.WXconfig.swapTitleInWX)) {
              info.title = data.summary;
            } else {
              info.title = data.title;
            }
            info.share_type = type;
            info.back = true;
            window.mqq.ui.shareMessage(info, function (result) {
              if (result.retCode === 0) {
                data.callback && data.callback.call(this, result);
              }
            });
          });
        } else {
          window.mqq.data.setShareInfo(info);
        }
      } catch (e) {}
    }
    if (window.mqq) {
      doQQShare();
    } else {
      require([qqapi], function () {
        doQQShare();
      });
    }
  }
  function _initQZ(data) {
    function doQZShare() {
      if (QZAppExternal && QZAppExternal.setShare) {
        var imageArr = [],
            titleArr = [],
            summaryArr = [],
            shareURLArr = [];
        for (var i = 0; i < 5; i++) {
          imageArr.push(data.pic);
          shareURLArr.push(data.url);
          if (i === 4 && (data.swapTitle || data.WXconfig && data.WXconfig.swapTitleInWX)) {
            titleArr.push(data.summary);
            summaryArr.push(data.title);
          } else {
            titleArr.push(data.title);
            summaryArr.push(data.summary);
          }
        }
        QZAppExternal.setShare(function (data) {}, { "type": "share", "image": imageArr, "title": titleArr, "summary": summaryArr, "shareURL": shareURLArr });
      }
    }
    if (window.QZAppExternal) {
      doQZShare();
    } else {
      require([qzapi], function () {
        doQZShare();
      });
    }
  }

  function _initSMGFSQ(data) {
    var info = { title: data.title, desc: data.summary, link: data.url, imgUrl: data.pic };
    function doSmShare() {
      try {
        window.smgfsq.initShareConfig(info);
      } catch (e) {
        console.log(e);
      }
    }

    if (window.smgfsq) {
      doSmShare();
    } else {
      require([smapi], function () {
        doSmShare();
      });
    }
  }
  function init(opts) {
    var ua = navigator.userAgent;
    var isWX = ua.match(/MicroMessenger\/([\d\.]+)/),
        isQQ = ua.match(/QQ\/([\d\.]+)/),
        isQZ = ua.indexOf("Qzone/") !== -1,
        isSMGFSQ = ua.match(/(SMGFSQ)/);
    isWX && _initWX(opts);
    isQQ && _initQQ(opts);
    isQZ && _initQZ(opts);
    isSMGFSQ && _initSMGFSQ(opts);
  }
  if ("function" === "function" && (__webpack_require__(180).cmd || __webpack_require__(445))) {
    if (__webpack_require__(180).cmd) {
      require = seajs.use;
    } else {
      require = _require;
    }
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return init;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    require = _require;
    window.setShareInfo = init;
  }
})();

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: '/',
    name: 'main',
    meta: {
        title: '首页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(482)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/test',
    name: 'test',
    meta: {
        title: 'Test'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(483)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/share',
    name: 'share',
    meta: {
        title: '分享测试'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(484)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/thread/show',
    name: 'forumThreadTest',
    meta: {
        title: '帖子详情'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(485)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/thread/error',
    name: 'forumThreadError',
    meta: {
        title: '蜀门手游-错误页面'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(486)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/self_help/main',
    name: 'forumSelf_helpMain',
    meta: {
        title: '蜀门手游-意见反馈'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(487)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/big_event/main',
    name: 'forumBig_eventMain',
    meta: {
        title: '蜀门手游-大事记'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(488)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/chest/main',
    name: 'forumChestMain',
    meta: {
        title: '蜀门手游-百宝箱'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(489)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/raiders/main',
    name: 'forumRaidersMain',
    meta: {
        title: '蜀门手游-攻略站'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(490)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/labour/main',
    name: 'forumLabourMain',
    meta: {
        title: '蜀门手游-公会分享'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(491)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/welfare',
    name: 'ActivityWelfare',
    meta: {
        title: '蜀门手游-福利中心'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(492)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/wish',
    name: 'ActivityWish',
    meta: {
        title: '蜀门手游-许愿池'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(493)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/means/main',
    name: 'forumMeansMain',
    meta: {
        title: '蜀门手游-资料站'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(494)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/writer/main',
    name: 'forumWriterMain',
    meta: {
        title: '蜀门手游-写手团报名'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(495)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/answer/main',
    name: 'forumAnswerMain',
    meta: {
        title: '蜀门手游-答题器'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(496)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/means/details',
    name: 'forumMeansDetails',
    meta: {
        title: '蜀门手游-资料站'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(497)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/forum/fate/main',
    name: 'forumFateMain',
    meta: {
        title: '蜀门手游-老黄历'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(498)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/lottery',
    name: 'activityLottery',
    meta: {
        title: '转盘抽奖'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(499)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/lottery426',
    name: 'activityLottery426',
    meta: {
        title: '转盘抽奖'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(500)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/lottery802',
    name: 'activityLottery802',
    meta: {
        title: '转盘抽奖'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(501)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/lottery180720',
    name: 'activityLottery180720',
    meta: {
        title: '转盘抽奖'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(502)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/lottery181225',
    name: 'activityLottery181225',
    meta: {
        title: '转盘抽奖'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(503)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/blessing/blessing',
    name: 'activityBlessingBlessing',
    meta: {
        title: '蜀门点赞'
    },
    children: [{
        path: '/activity/blessing/send',
        name: 'activityBlessingSend',
        meta: {
            title: '送祝福'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(504)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/blessing/top',
        name: 'activityBlessingTop',
        meta: {
            title: 'Top祝福'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(505)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/blessing/more',
        name: 'activityBlessingMore',
        meta: {
            title: '更多祝福'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(506)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/blessing/mine',
        name: 'activityBlessingMine',
        meta: {
            title: '我的祝福'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(507)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }],
    component: function component(resolve) {
        return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(508)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/blessing/canvass',
    name: 'activityBlessingCanvass',
    meta: {
        title: '蜀门点赞拉票'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(509)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/chest',
    name: 'activityChest',
    meta: {
        title: '天降宝箱 抢码狂欢'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(510)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/activation',
    name: 'activation',
    meta: {
        title: '确认激活'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(511)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/help/helpexplain',
    name: 'helpexplain',
    meta: {
        title: '公会帮助说明'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(512)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/help/helpforguild',
    name: 'helpforguild',
    meta: {
        title: '公会平台帮助说明'
    },
    component: function component(resolve) {
        return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [!(function webpackMissingModule() { var e = new Error("Cannot find module \"PAGE/help/Helpforguild.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/help/gradeexplain',
    name: 'gradeexplain',
    meta: {
        title: '公会等级帮助说明'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(513)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/help/pointrule',
    name: 'pointrule',
    meta: {
        title: '积分规则'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(514)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/newyear',
    name: 'newyear',
    meta: {
        title: '春节活动'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(515)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo/photos',
    name: 'activityPhotoPhotos',
    meta: {
        title: '爆照活动第一季'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(516)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo/message',
    name: 'activityPhotoMessage',
    meta: {
        title: '爆照活动第一季信息登记'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(517)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo/center',
    name: 'activityPhotoCenter',
    meta: {
        title: '爆照活动第一季个人中心'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(518)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo/pagelist',
    name: 'activityPhotoPagelist',
    meta: {
        title: '爆照活动第一季展示列表'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(519)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo_two/photos',
    name: 'activityPhotoTwoPhotos',
    meta: {
        title: '爆照活动第二季'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(520)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo_two/message',
    name: 'activityPhotoTwoMessage',
    meta: {
        title: '爆照活动第二季信息登记'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(521)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo_two/center',
    name: 'activityPhotoTwoCenter',
    meta: {
        title: '爆照活动第二季个人中心'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(522)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/photo_two/pagelist',
    name: 'activityPhotoTwoPagelist',
    meta: {
        title: '爆照活动第二季展示列表'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(523)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/loving/loving',
    name: 'activityLovingLoving',
    meta: {
        title: '蜀门表白'
    },
    children: [{
        path: '/activity/loving/send',
        name: 'activityLovingSend',
        meta: {
            title: '我要表白'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(524)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/loving/top',
        name: 'activityLovingTop',
        meta: {
            title: 'Top表白'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(525)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/loving/more',
        name: 'activityLovingMore',
        meta: {
            title: '更多表白'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(526)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/loving/mine',
        name: 'activityLovingMine',
        meta: {
            title: '我的表白'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(527)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }],
    component: function component(resolve) {
        return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [!(function webpackMissingModule() { var e = new Error("Cannot find module \"PAGE/activity/loving/Loving.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/loving/canvass',
    name: 'activityLovingCanvass',
    meta: {
        title: '蜀门表白拉票'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(528)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/qixi/loving',
    name: 'activityQixiLoving',
    meta: {
        title: '七夕活动-仙侣表白'
    },
    component: function component(resolve) {
        return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [!(function webpackMissingModule() { var e = new Error("Cannot find module \"PAGE/activity/qixi/Loving.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/qixi/index',
    name: 'activityQixiIndex',
    meta: {
        title: '七夕活动-首页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(529)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/qixi/mine',
    name: 'activityQixiMine',
    meta: {
        title: '七夕活动-个人资料'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(530)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/activity/qixi/send',
    name: 'activityQixiSend',
    meta: {
        title: '七夕活动-表白'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(531)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}];

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(474);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(475);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Client = function () {
	function Client() {
		(0, _classCallCheck3.default)(this, Client);

		this.ua = navigator.userAgent;
	}

	(0, _createClass3.default)(Client, [{
		key: "isIos",
		value: function isIos() {
			return this.ua.match(/(iPhone\sOS)\s([\d_]+)/) || this.ua.match(/(iPad).*OS\s([\d_]+)/);
		}
	}, {
		key: "isAndroid",
		value: function isAndroid() {
			return this.ua.match(/(Android)\s([\d_]+)/);
		}
	}, {
		key: "isClient",
		value: function isClient() {
			return this.isAndroid() || this.isIos();
		}
	}, {
		key: "isApp",
		value: function isApp() {
			return this.ua.match(/(SMGFSQ)/) || this.isClient() && !this.isWx() && !this.isH5();
		}
	}, {
		key: "isWx",
		value: function isWx() {
			return this.ua.match(/(MicroMessenger)/);
		}
	}, {
		key: "isH5",
		value: function isH5() {
			return this.ua.match(/(Safari)/);
		}
	}]);
	return Client;
}();

exports.default = Client;

/***/ })

},[209]);


// WEBPACK FOOTER //
// static/js/app.8fc22b6910ffc609d424.js